export default __webpack_public_path__ + "static/media/Maternidad.7ef0a21b.svg";